import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element).find('a.photo-link').simpleLightbox();
  }

  disconnect() {}
}
